// Module
var code = "<div ref=\"changePasswordContainer\">\n    <cjs-button ref=\"changePasswordDialogButton\"></cjs-button>\n</div>";
// Exports
module.exports = code;